(function () {
  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('.btn');
      if (!trigger) return;
      var section = trigger.closest('[id$="countdown_timer_qNViiD"]');
      if (!section) return;
      var dialog = document.querySelector('#PriceDropsSignup');
      if (!dialog || typeof dialog.showDialog !== 'function') return;
      event.preventDefault();
      dialog.showDialog();
    },
    true
  );

  // IMPORTANT: do NOT intercept/prevent this form's submit with fetch() — Shopify's native
  // customer-form endpoint requires a real, browser-triggered submission for its bot/CAPTCHA
  // check to attach a token (confirmed via testing: a fetch() POST is rejected outright with
  // "Missing CAPTCHA token", 100% of the time). So the real navigation must be allowed to happen.
  //
  // The freeze this was built to fix: because this form's native submission causes a real
  // page navigation, and our dialog is a native <dialog> opened via showModal(), a slow/stalled
  // destination load can leave our modal (and its scroll-lock) stuck open on top of the old
  // page indefinitely — reproduced live as a fully unresponsive tab. Proactively closing our
  // own dialog the instant the user submits (without preventing the submit) means the modal is
  // already tearing itself down — releasing scroll-lock/focus-trap — while the real navigation
  // is in flight, instead of remaining a stuck open modal on top of whatever loads next.
  document.addEventListener(
    'submit',
    function (event) {
      var dialog = document.querySelector('#PriceDropsSignup');
      if (!dialog) return;
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !dialog.contains(form)) return;
      if (typeof dialog.closeDialog === 'function') dialog.closeDialog();
    },
    true
  );
})();
